import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Svg from '../../../../../shared/Svg'
import { UP, DOWN } from './constants'

import styles from './Chevron.module.scss'

const propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf([UP, DOWN]).isRequired
}

const defaultProps = {
  direction: UP
}

const POINTS = {
  [UP]: '16.5,1 32,8.6 31.2,10 16.5,2.7 1.8,10 1,8.6',
  [DOWN]: '16.5,10.5 32,2.5 31.2,1 16.5,8.6 1.8,1 1,2.5'
}

const Chevron = ({ className = '', direction, ...restProps }) => (
  <Svg viewBox='0 0 33 11' className={classnames(className, styles.root)} {...restProps}>
    <polygon className={styles.arrow} points={POINTS[direction]} />
  </Svg>
)

Chevron.propTypes = propTypes
Chevron.defaultProps = defaultProps

export default Chevron
